import type { PromptLabel } from '../services/projects.api';

export interface PromptLabelMeta {
  value: PromptLabel;
  text: string;
  chip: string;
  description: string;
}

/**
 * Single source of truth for prompt-version labels. Keys mirror the backend
 * `promptLabels` enum in `apps/lidz_back/src/models/PromptVersion.ts`.
 */
export const PROMPT_LABEL_META: Record<PromptLabel, PromptLabelMeta> = {
  production: {
    value: 'production',
    text: 'Production',
    chip: 'bg-emerald-100 text-emerald-700',
    description: 'Versión activa que usa el agente',
  },
  latest: {
    value: 'latest',
    text: 'Latest',
    chip: 'bg-indigo-50 text-indigo-600',
    description: 'Versión más reciente que usa Demo Chat',
  },
  deprecated: {
    value: 'deprecated',
    text: 'Deprecated',
    chip: 'bg-gray-100 text-gray-600',
    description: 'Versión retirada, ya no en uso',
  },
};

/** Display order used across the version list and dialogs. */
export const PROMPT_LABEL_ORDER = ['production', 'latest', 'deprecated'] as const satisfies readonly PromptLabel[];

export const ASSIGNABLE_LABELS = ['production', 'latest', 'deprecated'] as const satisfies readonly PromptLabel[];

export const PUBLISHABLE_LABELS = ['production', 'latest'] as const satisfies readonly PromptLabel[];

export const isPromptLabel = (label: string | null): label is PromptLabel =>
  label !== null && Object.hasOwn(PROMPT_LABEL_META, label);
